// extracted by mini-css-extract-plugin
export default {"header__description":"Lyt4z"};